import PigletUnitApi from "@/api/piglet/pigletUnitApi";

export default {
  namespaced: true,
  mutations: {},
  actions: {
    async fetchByStorageId({dispatch}, storageId) {
      try {
        const response = await PigletUnitApi.fetchByStorageId(storageId);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true})
        return await Promise.reject(error);
      }
    }
  }
}
